export default __webpack_public_path__ + "52e1a319e03096d35479f226489c64ab.svg";